import { Smartphone, CheckCircle, ShieldCheck, Battery, AlertTriangle } from 'lucide-react';

const ShowcaseSection = () => {
  const benefits = [
    { icon: ShieldCheck, text: 'Garantie 6 mois' },
    { icon: CheckCircle, text: 'Testé et vérifié' },
    { icon: Battery, text: 'Batterie contrôlée' },
  ];

  return (
    <section
      id="vitrine"
      className="section-spacing relative overflow-hidden"
      data-testid="showcase-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-amber-50/30 to-white" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-80 h-80 bg-gradient-to-br from-amber-400/15 to-orange-400/15 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-gradient-to-br from-yellow-400/10 to-amber-400/10 rounded-full blur-3xl" />

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-amber-100 to-orange-100 rounded-full mb-6">
            <Smartphone size={16} className="text-amber-600" />
            <span className="text-amber-700 font-semibold text-sm uppercase tracking-wider" data-testid="showcase-label">
              iPhones d'occasion
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6" data-testid="showcase-title">
            Notre vitrine d'iPhones{' '}
            <span className="bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent">d'occasion</span>
          </h2>
          <p className="text-lg text-slate-600" data-testid="showcase-description">
            Des iPhones de seconde main, testés et garantis — et
            {' '}<span className="font-semibold text-slate-900">100 % pièces d'origine Apple</span>.
            Passez en boutique pour découvrir notre sélection&nbsp;!
          </p>

          {/* Occasion vs reconditionné explainer */}
          <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto text-left" data-testid="occasion-vs-recond">
            <div className="relative rounded-2xl p-5 bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200/60">
              <div className="absolute -top-3 left-5 px-2.5 py-0.5 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] font-bold uppercase tracking-wider">
                Ce qu'on vend
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-1.5 flex items-center gap-2">
                <span className="inline-flex w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-500 items-center justify-center text-white shrink-0">
                  <ShieldCheck size={15} strokeWidth={2.5} />
                </span>
                Occasion
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                iPhone de seconde main avec <span className="font-semibold text-slate-900">toutes ses pièces d'origine Apple</span>.
                Durabilité et compatibilité préservées — seule la <span className="font-semibold text-slate-900">batterie est remplacée si nécessaire</span>.
              </p>
            </div>

            <div className="relative rounded-2xl p-5 bg-slate-50 border border-slate-200">
              <div className="absolute -top-3 left-5 px-2.5 py-0.5 rounded-full bg-slate-700 text-white text-[10px] font-bold uppercase tracking-wider">
                À ne pas confondre
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-1.5 flex items-center gap-2">
                <span className="inline-flex w-7 h-7 rounded-full bg-gradient-to-br from-amber-500 to-orange-500 items-center justify-center text-white shrink-0">
                  <AlertTriangle size={15} strokeWidth={2.5} />
                </span>
                Reconditionné
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Mélange de pièces, souvent <span className="font-semibold text-slate-900">des composants génériques remplacés</span>.
                Moins de garantie sur la longévité et la compatibilité avec les mises à jour.
              </p>
            </div>
          </div>

          {/* Benefits */}
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-amber-200/50 shadow-sm"
              >
                <benefit.icon size={18} className="text-amber-600" />
                <span className="text-slate-700 font-medium text-sm">{benefit.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-6 border border-amber-200/50">
            <div className="text-left">
              <p className="font-bold text-slate-900">Tout notre stock est en boutique !</p>
              <p className="text-slate-600 text-sm">Venez découvrir et essayer notre sélection d'iPhones d'occasion</p>
            </div>
            <a
              href="#contact"
              className="px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-xl hover:shadow-lg hover:shadow-amber-500/30 transition-all hover:-translate-y-0.5 whitespace-nowrap"
            >
              Nous trouver
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShowcaseSection;
